"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignableTransactionV2 = exports.DEFAULT_GAS_LIMIT = void 0;
var big_js_1 = __importDefault(require("big.js"));
var ow_1 = __importDefault(require("ow"));
var long_1 = __importDefault(require("long"));
var secp256k1_1 = __importDefault(require("secp256k1"));
var tx_1 = require("@cosmjs/proto-signing/build/codec/cosmos/tx/v1beta1/tx");
var snakecaseKeys = __importStar(require("snakecase-keys"));
var codec_1 = require("../cosmos/v1beta1/codec");
var adr27_1 = require("../cosmos/v1beta1/adr27");
var hash_1 = require("../utils/hash");
var bytes_1 = require("../utils/bytes/bytes");
var types_1 = require("./types");
var ow_types_1 = require("./ow.types");
var ow_types_2 = require("../utils/bytes/ow.types");
var signed_1 = require("./signed");
var legacyAmino = __importStar(require("../cosmos/amino"));
var txDecoder_1 = require("../utils/txDecoder");
var ow_types_3 = require("../ow.types");
var cro_1 = require("../core/cro");
var typeurl_1 = require("./common/constants/typeurl");
var txBodyMessage_1 = require("../utils/protoBuf/encoder/txBodyMessage");
var v2_authInfo_1 = require("../utils/protoBuf/encoder/v2.authInfo");
exports.DEFAULT_GAS_LIMIT = 200000;
var SignableTransactionV2 = (function () {
    function SignableTransactionV2(params) {
        this.txBody = {
            typeUrl: '/cosmos.tx.v1beta1.TxBody',
            value: {
                messages: [],
                memo: '',
                timeoutHeight: '0',
            },
        };
        this.authInfo = {
            signerInfos: [],
            fee: {
                gasLimit: new big_js_1.default(exports.DEFAULT_GAS_LIMIT),
            },
        };
        this.signerAccounts = [];
        ow_1.default(params, 'params', ow_types_1.owSignableTransactionParamsV2);
        this.network = params.network;
        var cosmosTxDecoded = JSON.parse(params.rawTxJSON);
        var cosmosObj = cosmosTxDecoded;
        if (!cosmosObj.body) {
            throw new Error('Missing body in Cosmos JSON');
        }
        var body = cosmosObj.body;
        var memo = body.memo;
        var timeoutHeight = body.timeout_height;
        if ((body.non_critical_extension_options && body.non_critical_extension_options.length > 0) ||
            (body.extension_options && body.extension_options.length > 0)) {
            throw new Error("SignableTransactionV2 doesn't support 'nonCriticalExtensionOptions' or 'extensionOptions'");
        }
        if (!body.messages || body.messages.length < 1) {
            throw new Error('Decoded TxBody does not have valid messages');
        }
        var croSdk = cro_1.CroSDK({ network: this.getNetwork() });
        var txBody = {
            typeUrl: '/cosmos.tx.v1beta1.TxBody',
            value: {
                messages: [],
                memo: memo,
                timeoutHeight: timeoutHeight,
            },
        };
        body.messages.forEach(function (message) {
            var msgClassInstance = typeurl_1.typeUrlToMsgClassMapping(croSdk, message['@type']);
            var nativeMsg = msgClassInstance.fromCosmosMsgJSON(JSON.stringify(message));
            txBody.value.messages.push(nativeMsg);
        });
        if (typeof cosmosObj.auth_info === 'undefined') {
            throw new Error('Decoded Tx does not have a valid `authInfo`');
        }
        var cosmosAuthInfo = cosmosObj.auth_info;
        var cosmosSignerInfos = cosmosAuthInfo.signer_infos;
        var signerInfos = [];
        cosmosSignerInfos.forEach(function (signerInfo) {
            var _a, _b;
            var publicKeyObj = signerInfo.public_key;
            if (!signerInfo.mode_info.single) {
                throw new Error('SignableTransactionV2 only supports single signer mode.');
            }
            var pubKey = publicKeyObj.key;
            var signMode;
            switch ((_a = signerInfo.mode_info.single) === null || _a === void 0 ? void 0 : _a.mode) {
                case 'SIGN_MODE_DIRECT':
                    signMode = codec_1.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_DIRECT;
                    break;
                case 'SIGN_MODE_LEGACY_AMINO_JSON':
                    signMode = codec_1.cosmos.tx.signing.v1beta1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
                    break;
                default:
                    throw new Error("Unsupported sign mode: " + ((_b = signerInfo.mode_info.single) === null || _b === void 0 ? void 0 : _b.mode));
            }
            signerInfos.push({
                publicKey: bytes_1.Bytes.fromBase64String(pubKey),
                modeInfo: {
                    single: {
                        mode: signMode,
                    },
                },
                sequence: new big_js_1.default(signerInfo.sequence),
            });
        });
        if (typeof cosmosAuthInfo.fee === 'undefined' || typeof cosmosAuthInfo.fee.amount === 'undefined') {
            throw new Error('Decoded Tx AuthInfo does not have a valid `fee`');
        }
        var feeAmountList = cosmosAuthInfo.fee.amount.map(function (feeAmount) {
            var feeAmountString = feeAmount.amount;
            var feeAmountDenom = feeAmount.denom;
            var feeAmountCoin = croSdk.v2.CoinV2.fromCustomAmountDenom(feeAmountString, feeAmountDenom);
            return feeAmountCoin;
        });
        var authInfo = {
            signerInfos: signerInfos,
            fee: {
                amount: feeAmountList || undefined,
                gasLimit: new big_js_1.default(cosmosAuthInfo.fee.gas_limit || exports.DEFAULT_GAS_LIMIT),
                payer: cosmosAuthInfo.fee.payer,
                granter: cosmosAuthInfo.fee.granter,
            },
        };
        if (authInfo.signerInfos.length === 0) {
            throw new TypeError('Expected signer in `signerInfos` of `authInfo` of `params`, got none');
        }
        this.txBody = txBody;
        this.authInfo = authInfo;
        var signatures = cosmosObj.signatures.length > 0
            ? cosmosObj.signatures.map(function (sigStr) {
                return bytes_1.Bytes.fromBase64String(sigStr);
            })
            : authInfo.signerInfos.map(function () { return types_1.EMPTY_SIGNATURE; });
        var bodyBytes = txBodyMessage_1.protoEncodeTxBody(txBody);
        var authInfoBytes = v2_authInfo_1.protoEncodeAuthInfoV2(authInfo);
        this.txRaw = {
            bodyBytes: bodyBytes,
            authInfoBytes: authInfoBytes,
            signatures: signatures,
        };
        this.network = params.network;
        this.signerAccounts = params.signerAccounts || [];
    }
    SignableTransactionV2.prototype.importSignerAccounts = function (signerAccounts) {
        this.signerAccounts = signerAccounts;
        return this;
    };
    SignableTransactionV2.prototype.toSignDocument = function (index) {
        ow_1.default(index, 'index', this.owIndex());
        var signMode = this.getSignerSignMode(index);
        if (signMode === types_1.SIGN_MODE.DIRECT) {
            return makeSignDoc(this.txRaw.bodyBytes, this.txRaw.authInfoBytes, this.network.chainId, this.signerAccounts[index].accountNumber);
        }
        if (signMode === types_1.SIGN_MODE.LEGACY_AMINO_JSON) {
            return makeLegacyAminoSignDoc(legacyEncodeMsgs(this.txBody.value.messages), legacyEncodeStdFee(this.authInfo.fee.amount, this.authInfo.fee.gasLimit), this.network.chainId, this.txBody.value.memo || '', this.signerAccounts[index].accountNumber.toString(), this.authInfo.signerInfos[index].sequence.toString(), legacyEncodeTimeoutHeight(this.txBody.value.timeoutHeight));
        }
        throw new Error("Unrecognized sign mode: " + signMode);
    };
    SignableTransactionV2.prototype.setSignerAccountNumberAtIndex = function (index, accountNumber) {
        ow_1.default(accountNumber, 'accountNumber', ow_types_3.owBig());
        ow_1.default(index, 'index', this.owIndex());
        this.signerAccounts[index].accountNumber = accountNumber;
        return this;
    };
    SignableTransactionV2.prototype.toSignDocumentHash = function (index) {
        var raw = this.toSignDocument(index);
        var hash = hash_1.sha256(raw);
        return hash;
    };
    SignableTransactionV2.prototype.toSignDoc = function (index) {
        return this.toSignDocumentHash(index);
    };
    SignableTransactionV2.prototype.setSignature = function (index, signature) {
        ow_1.default(index, 'index', this.owIndex());
        ow_1.default(signature, 'signature', ow_types_2.owBytes());
        var pubKey = this.signerAccounts[index].publicKey;
        var signDocHash = this.toSignDocumentHash(index);
        if (!secp256k1_1.default.ecdsaVerify(signature.toUint8Array(), signDocHash.toUint8Array(), pubKey.toUint8Array())) {
            throw new Error('Invalid signature');
        }
        this.txRaw.signatures[index] = signature;
        return this;
    };
    SignableTransactionV2.prototype.getSignerSignMode = function (index) {
        return this.signerAccounts[index].signMode;
    };
    SignableTransactionV2.prototype.isIndexSigned = function (index) {
        ow_1.default(index, 'index', this.owIndex());
        return !this.txRaw.signatures[index].isEqual(types_1.EMPTY_SIGNATURE);
    };
    SignableTransactionV2.prototype.owIndex = function () {
        var _this = this;
        return ow_1.default.number.integer.greaterThanOrEqual(0).validate(function (val) { return ({
            validator: val < _this.signerAccounts.length,
            message: function (label) { return "Expected `" + label + "` to be within signer size, got `" + val + "`"; },
        }); });
    };
    SignableTransactionV2.prototype.getTxRaw = function () {
        return this.txRaw;
    };
    SignableTransactionV2.prototype.getNetwork = function () {
        return this.network;
    };
    SignableTransactionV2.prototype.toSigned = function () {
        if (!this.isCompletelySigned()) {
            throw new Error('Transaction is not completed signed');
        }
        return new signed_1.SignedTransaction(this.txRaw);
    };
    SignableTransactionV2.prototype.isCompletelySigned = function () {
        return this.txRaw.signatures.every(function (signature) { return !signature.isEqual(types_1.EMPTY_SIGNATURE); });
    };
    SignableTransactionV2.prototype.toCosmosJSON = function () {
        var txObject = {
            body: Object.create({}),
            authInfo: Object.create({}),
            signatures: Object.create([[]]),
        };
        try {
            var nativeAuthInfo = tx_1.AuthInfo.decode(this.txRaw.authInfoBytes.toUint8Array());
            var nativeTxBody = tx_1.TxBody.decode(this.txRaw.bodyBytes.toUint8Array());
            var nativeSignaturesList = this.getTxRaw().signatures.map(function (byteSig) { return byteSig.toUint8Array(); });
            txObject.authInfo = txDecoder_1.getAuthInfoJson(nativeAuthInfo);
            txObject.body = txDecoder_1.getTxBodyJson(nativeTxBody);
            txObject.signatures = txDecoder_1.getSignaturesJson(nativeSignaturesList);
            var stringifiedTx = JSON.stringify(snakecaseKeys.default(txObject));
            var cosmosApiFormatTxJson = txDecoder_1.typeUrlToCosmosTransformer(stringifiedTx);
            return cosmosApiFormatTxJson;
        }
        catch (error) {
            throw new Error('Error converting SignableTransactionV2 to Cosmos compatible JSON.');
        }
    };
    return SignableTransactionV2;
}());
exports.SignableTransactionV2 = SignableTransactionV2;
var makeSignDoc = function (txBodyBytes, authInfoBytes, chainId, accountNumber) {
    var signDoc = adr27_1.omitDefaults({
        bodyBytes: txBodyBytes.toUint8Array(),
        authInfoBytes: authInfoBytes.toUint8Array(),
        chainId: chainId,
    });
    if (accountNumber.toNumber()) {
        signDoc.accountNumber = long_1.default.fromNumber(accountNumber.toNumber());
    }
    var signDocProto = codec_1.cosmos.tx.v1beta1.SignDoc.create(signDoc);
    return bytes_1.Bytes.fromUint8Array(codec_1.cosmos.tx.v1beta1.SignDoc.encode(signDocProto).finish());
};
var legacyEncodeMsgs = function (msgs) {
    return msgs.map(function (msg) { return msg.toRawAminoMsg(); });
};
var legacyEncodeStdFee = function (feeAmountList, gas) {
    return {
        amount: feeAmountList ? feeAmountList.map(function (feeAmount) { return feeAmount.toCosmosCoin(); }) : [],
        gas: gas ? gas.toString() : exports.DEFAULT_GAS_LIMIT.toString(),
    };
};
var legacyEncodeTimeoutHeight = function (timeoutHeight) {
    if (typeof timeoutHeight === 'undefined' || timeoutHeight === '0') {
        return undefined;
    }
    return timeoutHeight;
};
var makeLegacyAminoSignDoc = function (msgs, fee, chainId, memo, accountNumber, sequence, timeoutHeight) {
    var encodedTimeoutHeight;
    if (typeof timeoutHeight !== 'undefined') {
        encodedTimeoutHeight = legacyAmino.Uint53.fromString(timeoutHeight.toString()).toString();
    }
    var stdSignDocBase = {
        chain_id: chainId,
        account_number: legacyAmino.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: legacyAmino.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo,
    };
    var stdSignDoc;
    if (typeof timeoutHeight === 'undefined') {
        stdSignDoc = __assign({}, stdSignDocBase);
    }
    else {
        stdSignDoc = __assign(__assign({}, stdSignDocBase), { timeout_height: encodedTimeoutHeight });
    }
    return bytes_1.Bytes.fromUint8Array(legacyAmino.toUtf8(legacyAmino.sortedJsonStringify(stdSignDoc)));
};
//# sourceMappingURL=v2.signable.js.map